import { render, staticRenderFns } from "./UserRoleDetail.vue?vue&type=template&id=39b28a54"
import script from "./UserRoleDetail.vue?vue&type=script&lang=js"
export * from "./UserRoleDetail.vue?vue&type=script&lang=js"
import style0 from "./UserRoleDetail.vue?vue&type=style&index=0&id=39b28a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports